import { createRouteContext } from '@/providers';
import { CampaignPlannerRoute } from '@/types/routes';

const {
    RouteProvider: CampaignPlannerRouteProvider,
    useRouteContext: useCampaignPlannerRoute,
} = createRouteContext<CampaignPlannerRoute>();

export { CampaignPlannerRouteProvider, useCampaignPlannerRoute };
